import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { capitalize, isStringValueTruthy } from 'lib/utils/common/commonUtils'

export function getFeature(key, details, t) {
  const parsedKey = key.split('_').join(' ')
  const value = details[key]

  if (isStringValueTruthy(value)) {
    return (
      <div className="feature" key={key}>
        <span className={clsx('feature__title', Typo.body2)}>
          {capitalize(t(parsedKey))}
        </span>
        <span className={clsx('feature__information', Typo.caption)}>
          {value}
        </span>
      </div>
    )
  }

  return null
}

const ProductCareInstructions = ({ details, t }) => (
  <div className="pdp__care-instructions">
    {Object.keys(details).map((key) => getFeature(key, details, t))}
  </div>
)

ProductCareInstructions.propTypes = {
  details: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ProductCareInstructions)
